module.exports = __webpack_public_path__ + "media/images/help/image-person-b28a634deeaddaa5c3577c912d1e7b08.jpg";